export const COST_FACTOR = 1.58;
export const MIN_PAY = 4 * 100;
export const MAX_PAY = 1000 * 100;
export const MIN_BILLING_RATE = 22 * 100;
